import * as axiosService from "../axiosService";
export const FulfilmentDashboardMetric = (payload) => {    
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/LiveLoads/FulfilmentDashboardMetric`, payload);
};

export const GetFulfillmentFiltersData = () => {    
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/LiveLoads/GetFulfillmentFiltersData`);
};

